export const commonTheme = {
    "palette": {
        "primary": {
            "main": "#000000b3"
        },
        "secondary": {
            "main": "#A140E7"
        },
        "background": {
            "default": "#fff",
            "paper": "#fff",
            "selectedChat": "#f1f5f9",
            "mainContainer": "#dbeafe",
            "userNameStyle": "#000000b3",
            "clientMsg": "#eff6ff",
            "recipientMsg": "#fff"
        },
        "text": {
            "primary": "#000000",
            "secondary": "#545455",
            "chatListText": "#545455"
        },
        "border": {
            "primary": "#0000001a"
        }
    }
}